import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef,
} from 'react';

import { 
  getFromURI
} from './IpfsApp';

import {
BrowserRouter as Router,
Route,
Link,
Routes
} from "react-router-dom";

import styled from 'styled-components';
import { Provider } from '../utils/provider';

import { Row, Col, Card, Button, Form } from 'react-bootstrap';

//CFX LIVE
import CFX_Artifact from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import CFX_Address from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken-address.json';

//CFALPHA LIVE
import CFALPHA_Artifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import CFALPHA_Address from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

//CFOG LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

//PLATECORE LIVE
import PlatecoreNFTArtifact from '../live_artifacts/contracts/PlatecoreNFT.sol/PlatecoreNFT.json';
import PlatecoreNFTAddress from '../live_artifacts/contracts/PlatecoreNFT.sol/PlatecoreNFT-address.json';

//PLANETOWNERLITE LIVE
import PlanetOwnerNFTArtifact from '../live_artifacts/contracts/PlanetOwnerLiteNFT.sol/PlanetOwnerLiteNFT.json';
import PlanetOwnerNFTAddress from '../live_artifacts/contracts/PlanetOwnerLiteNFT.sol/PlanetOwnerLiteNFT-address.json';

const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function PlanetOwnerLiteApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTCreateContract />
    </StyledAppDiv>
  );
}

export function NFTCreateContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buySTACKCOREButton, setBuyCFALPHAButton] = useState<string>('APPROVE BUSD & MINT $STACKCORE NFT');
  const [buyPLANETCFXButton, setBuyPlanetCFXButton] = useState<string>('APPROVE CFX');
  const [buyPLANETDUALButton, setBuyPlanetDUALButton] = useState<string>('LOADING PLATE CORES');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalCFXRaised, setTotalCFXRaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);
  const [totalMinted, setTotalMinted] = useState(0);

  const [totalRed, setTotalRed] = useState(0);
  const [totalGreen, setTotalGreen] = useState(0);
  const [totalBlue, setTotalBlue] = useState(0);
  const [totalCyan, setTotalCyan] = useState(0);
  const [totalMagenta, setTotalMagenta] = useState(0);
  const [totalYellow, setTotalYellow] = useState(0);

  const [nbrAlpha, setNbrAlpha] = useState<string>(''); // Alpha  NFT's
  const [nbrOG, setNbrOG] = useState<string>(''); // OG NFT's

  const [planetId, setPlanetId] = useState(0);
  const [planetName, setPlanetName] = useState('SELECT PLANET');
  const [planetImage, setPlanetImage] = useState('./images/ALL_0-1_small.png');

  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const [fuseItems, setFuseItems] = useState<any[]>([]);
  const [totalSelected, setTotalSelected] = useState(0);
  
  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

     //test for account change
     useEffect(() => {
      setFuseItems([]);
      setItems([]);
      setTotalSelected(0);
      handleAttachContract();
    }, [account]);

    //test for planet change
    useEffect(() => {
      handleAttachContract();
    }, [planetId]);

    //test for nbr DUAL change
    useEffect(() => {
      handleAttachContract();
    }, [totalSelected]);

    //test for nbr DUAL change
    useEffect(() => {
      handleAttachContract();
    }, [nbrAlpha]);

            //test for nbr DUAL change
    useEffect(() => {
      handleAttachContract();
    }, [nbrOG]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        PlanetOwnerNFTArtifact.abi,
        PlanetOwnerNFTArtifact.bytecode,
        signer
      );

      const PLATECORENFT = new ethers.ContractFactory(
        PlatecoreNFTArtifact.abi,
        PlatecoreNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFX');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(PlanetOwnerNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();

        const totalRed = await nftContract.totalRed();
        const totalGreen = await nftContract.totalGreen();
        const totalBlue = await nftContract.totalBlue();
        const totalCyan = await nftContract.totalCyan();
        const totalMagenta = await nftContract.totalMagenta();
        const totalYellow = await nftContract.totalYellow();

        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));
        setTotalMinted(Number(totalSupply));

        setTotalRed(Number(totalRed));
        setTotalGreen(Number(totalGreen));
        setTotalBlue(Number(totalBlue));
        setTotalCyan(Number(totalCyan));
        setTotalMagenta(Number(totalMagenta));
        setTotalYellow(Number(totalYellow));

        //Chech if BUSD approved and change to MINT buttin if so
        handleCheckApproveCFX();

        //testing if 0 for first time here...
        if (!totalSelected) {

          const PLATECOREnft = await PLATECORENFT.attach(PlatecoreNFTAddress.address);

          let listItems = [];

          const balancePLATECORENFT = await PLATECOREnft.balanceOf(account);

          for(let i =0; i < balancePLATECORENFT; i++){
            const tokenId = await PLATECOREnft.tokenOfOwnerByIndex(account,i);
            var uri = await PLATECOREnft.tokenURI(tokenId);
           
            const colour = await PLATECOREnft.getCore(tokenId);

            const metadata = getFromURI(uri);
        
          const itemId = (tokenId).toString();
          const colourBC = (colour).toString();
          const itemSelected = '0';

          let item = {
          //  itemIdHex: itemIdHex,
            itemId: itemId,
          //  price: metadata.price,
          //  name: metadata.name,
            description: metadata.description,
          //  ticker: metadata.ticker,
            image: metadata.image,
            colour: colourBC,
            selected: itemSelected
          }
          listItems.push(item);
  
          }

          setItems(listItems);
          setLoading(false);

      }

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }
  
  function handleCreateCFXNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    if (planetId == 0){
      window.alert('No Planet Selected - SELECT PLANET');
      return;
    }

    if (planetId == 1 && totalRed >= 50) {
      window.alert(`NO RED 1B 1.0% CO-OWNER NFTs AVAILABLE`);
      return;
    } else if (planetId == 2 && totalGreen >= 50) {
      window.alert(`NO GREEN 1F 1.0% CO-OWNER NFTs AVAILABLE`);
      return;
    } else if (planetId == 4 && totalBlue >= 50) {
      window.alert(`NO BLUE 1D 1.0% CO-OWNER NFTs AVAILABLE`);
      return;
    } else if (planetId == 8 && totalCyan >= 50) {
      window.alert(`NO CYAN 1G 1.0% CO-OWNER NFTs AVAILABLE`);
      return;
    } else if (planetId == 16 && totalMagenta >= 50) {
      window.alert(`NO MAGENTA 1H 1.0% CO-OWNER NFTs AVAILABLE`);
      return;
    } else if (planetId == 32 && totalYellow >= 50) {
      window.alert(`NO YELLOW 1C 1.0% CO-OWNER NFTs AVAILABLE`);
      return;
    }

    async function createNFT(signer: Signer, _planetId: Number): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        PlanetOwnerNFTArtifact.abi,
        PlanetOwnerNFTArtifact.bytecode,
        signer
      );

      const CFX = new ethers.ContractFactory(
        CFX_Artifact.abi,
        CFX_Artifact.bytecode,
        signer
      );

      const PLATECORENFT = new ethers.ContractFactory(
        PlatecoreNFTArtifact.abi,
        PlatecoreNFTArtifact.bytecode,
        signer
      );

      try {

        const CFX_Contract = await CFX.attach(CFX_Address.address);
      

        const amountApproved = await CFX_Contract.allowance(account, PlanetOwnerNFTAddress.address);
        const balanceCFX = await CFX_Contract.balanceOf(account);

        //************* = 750 with 18 0's */
        var cost = 750000000000000000000;

        // Deduct Dual Stacks 25 with 18 0's
        var dualAmount = totalSelected * 25000000000000000000;

        cost = cost - dualAmount;

        // Discount Implementation
        if (Number(nbrOG) > 0) {
          //Do 35% discount
          cost = (cost / 100) * 65;
        } else if (Number(nbrAlpha) > 0) {
            cost = (cost / 100) * 75;
        }

        var totalCost = Math.round((cost / 1000000000000000000) * 100) / 100;

        // TEST ADD BACK
        if(Number(balanceCFX) < cost ) {
          window.alert('Not enough CFX balance');
          return;
        }
        
        //If not enough allowence left
        if (Number(amountApproved) < cost) {
          //Do Approve CFX

          const listingPrice = ethers.utils.parseEther("30000");

       // TEST ADD BACK
          const setTxn = await CFX_Contract.approve(PlanetOwnerNFTAddress.address,listingPrice);
          await setTxn.wait();

          setBuyPlanetCFXButton(`MINT ${planetName} 0.1% CO-OWNER NFT WITH CFX`);
          setBuyPlanetDUALButton(`MINT ${planetName} 0.1% CO-OWNER NFT WITH ${totalSelected} PLATECORE(s) AND ${totalCost} CFX`);

          window.alert(`CFX Approve Success!`);
        }

         //Aprove for Duals
         if (dualAmount > 0) {

          const PLATECOREnft = await PLATECORENFT.attach(PlatecoreNFTAddress.address);
          
          const isApproved = await PLATECOREnft.isApprovedForAll(account, PlanetOwnerNFTAddress.address);

          if (!isApproved) {
              await(await PLATECOREnft.setApprovalForAll(PlanetOwnerNFTAddress.address, true)).wait();
              window.alert(`APPROVED ACCESS TO PLATECOREs`);
          }

        }

        const nftContract = await NFT.attach(PlanetOwnerNFTAddress.address);
       
        const ticker = "CFX";
        const tickerId = 1;
        const quantity = 1;

        const planetId = _planetId;
        var tokenId1 = 0;
        var tokenId2 = 0;
        var tokenId3 = 0;
        var tokenId4 = 0;

        if (fuseItems.length >= 1) {
          tokenId1 = Number(fuseItems[0].itemId);
        }

        if (fuseItems.length >= 2) {
          tokenId2 = Number(fuseItems[1].itemId);
        }

        if (fuseItems.length >= 3) {
          tokenId3 = Number(fuseItems[2].itemId);
        }

        if (fuseItems.length >= 4) {
          tokenId4 = Number(fuseItems[3].itemId);
        }
       
        // mint nft 
        // TEST ADD BACK
        await(await nftContract.mint(tickerId, planetId, tokenId1, tokenId2, tokenId3, tokenId4, {
         gasLimit: 980000
      })).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));
        setTotalMinted(Number(totalSupply));


        setBuyPlanetCFXButton(`MINT ${planetName} 0.1% CO-OWNER NFT WITH CFX`);
        setBuyPlanetDUALButton(`MINT ${planetName} 0.1% CO-OWNER NFT WITH ${totalSelected} PLATECORE(s) AND ${totalCost} CFX`);
        handleCheckApproveCFX();

        window.alert(`Created ${planetName} 0.1% Co-OWNER NFT ID: #${totalSupply} `);

        setFuseItems([]);
        setItems([]);
        setTotalSelected(0);

        //reload page
        setLoading(true);
        handleAttachContract();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer, planetId);
  }

  

  function handleCheckApproveCFX(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckCFX(signer: Signer, _planet: Number): Promise<void> {
        
        //   const BUSDLIVE = new ethers.ContractFactory(
        //     BUSD_LIVEArtifact.abi,
        //     BUSD_LIVEArtifact.bytecode,
        //     signer
        //   );
    
          const CFX = new ethers.ContractFactory(
            CFX_Artifact.abi,
            CFX_Artifact.bytecode,
            signer
          );

          const ALPHA = new ethers.ContractFactory(
            CFALPHA_Artifact.abi,
            CFALPHA_Artifact.bytecode,
            signer
          );
    
          const OG = new ethers.ContractFactory(
            OGNFTArtifact.abi,
            OGNFTArtifact.bytecode,
            signer
          );
    
          try {

            const CFX_Contract = await CFX.attach(CFX_Address.address);
            const ALPHA_Contract = await ALPHA.attach(CFALPHA_Address.address);
            const OG_Contract = await OG.attach(OGNFTAddress.address);
              
            const amountApproved = await CFX_Contract.allowance(account,PlanetOwnerNFTAddress.address);
    
            const contractBalanceCFX = await CFX_Contract.balanceOf(PlanetOwnerNFTAddress.address);     
            const totalSafuuRaised = Number(ethers.utils.formatUnits(contractBalanceCFX,18));
            setTotalCFXRaised(Math.ceil(totalSafuuRaised));
      
            const walletNewBalanceCFX = await CFX_Contract.balanceOf(account);
            const newBalanceCFX = Number(ethers.utils.formatUnits(walletNewBalanceCFX,18));
            setsafuuBalance(newBalanceCFX);

            //Test if any ALPHA NFT's exist does not use ethes 18 digs
            const walletBalanceCFALPHA = await ALPHA_Contract.balanceOf(account);

            //Test if any ALPHA OG's exist does not use ethes 18 digs
            const walletBalanceOG = await OG_Contract.balanceOf(account);

            if (Number(walletBalanceCFALPHA)){
              setNbrAlpha('1'); //Just set to 1 don't need actual total
            } else {
              setNbrAlpha('');
            }

            if (Number(walletBalanceOG)){
              setNbrOG('1');
            } else {
              setNbrOG('');
            }

            //************* = 750 with 18 )'s */
            var cost = 750000000000000000000;

            // Deduct Dual Stacks 25 with 18 0's
            var dualAmount = totalSelected * 25000000000000000000;

            cost = cost - dualAmount;

            // Discount Implementation
            if (Number(nbrOG) > 0) {
              //Do 35% discount
              cost = (cost / 100) * 65;
            } else if (Number(nbrAlpha) > 0) {
                cost = (cost / 100) * 75;
            }

            var totalCost = Math.round((cost / 1000000000000000000) * 100) / 100;
    
            if (planetName == 'SELECT PLANET'){
              setBuyPlanetCFXButton(`SELECT PLANET TO MINT 0.1% CO-OWNER NFT WITH CFX`); 
              setBuyPlanetDUALButton(`SELECT PLANET TO MINT 0.1% CO-OWNER NFT WITH ${totalSelected} PLATECORE(s) AND ${totalCost} CFX`);
                 
            }  else {
              //If not enough allowence left
              if (Number(amountApproved) >= cost) {
                setBuyPlanetCFXButton(`MINT ${planetName} 0.1% CO-OWNER NFT WITH CFX`);
                setBuyPlanetDUALButton(`MINT ${planetName} 0.1% CO-OWNER NFT WITH ${totalSelected} PLATECORE(s) AND ${totalCost} CFX`);
                
              } else {
                setBuyPlanetCFXButton(`APPROVE CFX & MINT ${planetName} 0.1% CO-OWNER NFT WITH CFX`);
                setBuyPlanetDUALButton(`APPROVE CFX & MINT ${planetName} 0.1% CO-OWNER NFT WITH ${totalSelected} PLATECORE(s) AND ${totalCost} CFX`);
              }
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckCFX(signer, planetId);
  }

  function handlePlanetChange(_planetName: string): void {
    
    setPlanetName(_planetName);
    setPlanetId(0);
    setPlanetImage('./images/ALL_0-1_small.png');

    if (_planetName == 'RED 1B'){
      setPlanetId(1);    
      setPlanetImage('./images/RED_0-1_small.png');  
    }  else if (_planetName == 'GREEN 1F') {
      setPlanetId(2);
      setPlanetImage('./images/GREEN_0-1_small.png');
    } else if (_planetName == 'BLUE 1D') {
      setPlanetId(4);
      setPlanetImage('./images/BLUE_V5_0-1_small.png');
    } else if (_planetName == 'CYAN 1G') {
      setPlanetId(8);
      setPlanetImage('./images/CYAN_0-1_small.png');
    } else if (_planetName == 'MAGENTA 1H') {
      setPlanetId(16);
      setPlanetImage('./images/MAGENTA_0-1_small.png');
    } else if (_planetName == 'YELLOW 1C') {
      setPlanetId(32);
      setPlanetImage('./images/YELLOW_0-1_small.png');
    }

  }

  function handleSelectChange(e: any, _item: any): void {

    var newTotalSelected=totalSelected;

    setTotalSelected(totalSelected+1);

    if (Number(_item.selected)) {
      _item.selected = '0';
      newTotalSelected--;
      var index = fuseItems.indexOf(_item);
      fuseItems.splice(index,1);
    } else {
      if (newTotalSelected == 4){
        //Already 4 selected
        e.target.checked = false;
        window.alert("SELECT MAX 4 $PLATECORE");
      } else {
        _item.selected = '1';
        newTotalSelected++;
        fuseItems.push(_item);
      }
    }

    setTotalSelected(newTotalSelected);

  }
    
  return (
    <>
      
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
            </h6>
            </Row>
            <Row className="g-4">
            <h1 className="text-center">
            PLANET 0.1% CO-OWNER NFT
            </h1>
            </Row>
            <Row className="g-4">
            <Col>
            <h4 className="text-center">
              Total Minted
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Max Supply (6 Planets)
            </h4>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            <h5 className="text-center">
              {totalMinted}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              6 x 50 = 300
            </h5>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="text-center">
            TOTAL 0.1% CO-OWNER NFTs MINTED PER PLANET
            </h5>
            </Row>
            <Row className="g-4">
            <Col>
            <h5 className="text-center">
              Red 1B
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              Yellow 1C
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              Blue 1D
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              Green 1F
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              Cyan 1G
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              Magenta 1H
            </h5>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            <h5 className="text-center">
            {totalRed}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
            {totalYellow}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
            {totalBlue}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
            {totalGreen}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
            {totalCyan}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
            {totalMagenta}
            </h5>
            </Col>
          </Row>
            <Row className="g-8">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '450px' }}>
            <img src= {planetImage} className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-4 text-center">
              750 $CFXv1 = 1 PLANET 0.1% CO-OWNER NFT
            </h5>
          </Row>
          <Row className="g-4">
            {nbrOG ? (
            <>
            <h6 className="p-2 text-center">
              OG NFT DETECTED - 35% DISCOUNT WILL APPLY
            </h6>
            </>
            ) : (
            <>
             <h6 className="p-2 text-center">
              {nbrAlpha ? 'ALPHA NFT DETECTED - 25% DISCOUNT WILL APPLY' : 'NO ALPHA OR OG NFT DETECTED - NO DISCOUNT WILL APPLY'}
             </h6>
            </>
            )}
          </Row>
          <Row className="g-4">
          <Col>
          </Col>
            <Col>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">Planet selection</label>
            <select onChange={(e) => handlePlanetChange(e.target.value)} className="form-control" id="FormControlQuantity">
              <option>SELECT PLANET</option>
              <option>RED 1B</option>
              <option>YELLOW 1C</option>
              <option>BLUE 1D</option>
              <option>GREEN 1F</option>
              <option>CYAN 1G</option>
              <option>MAGENTA 1H</option>
            </select>
          </div>
          </Col>
          <Col>
          </Col>
          </Row>
          <Form>
          <Row xs={1} md={2} lg={6} className="g-7 py-5">
            {items.map((item, idx) => (
              <Col key={idx}  className=" text-center py-0">
                <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                  <Card.Body>
                    <Card.Img variant="top" src={item.image} />
                    <Form.Check 
                      onChange={(e) => handleSelectChange(e, item)}
                      type="switch"
                      id={item.itemId}
                      label="Select"
                    />
                    </Card.Body>
                  <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b", padding: "0.2rem 0.2rem" }}>
                  <Card.Text>
                    <h6>#{item.itemId} {item.description} </h6>
                  </Card.Text>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
          </Form>
            <Row className="g-4">
            <Col>
            <div className="d-grid px-8">
              <Button onClick={handleCreateCFXNFT} variant="primary" size="lg">
                {buyPLANETDUALButton}
              </Button>
            </div>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            300 PLANET 0.1% CO-OWNER NFTs are on presale for 750 $CFX each. This represents 50 x 0.1% CO-OWNER NFTs per PLANET. You can apply your ALPHA 25% or OG 35% discount plus using the VALUE of up to 4 PLATE COREs towards to final price. PLATE CORE VALUE is deducted before OG or APLHA discount is applied. Total DISCOUNTS would give a price of 422.5 $CFX from the original price of 750 $CFX when fully using OG and 4 PLATE COREs. NOTE: STAKING NO LONGER APPLIES. 
            </h6>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            Exclusive Co-Ownership of each of the 6 Cosmic Force planets for early-stage investors. Passive income will come from ON-PLANET land purchases, mining revenue and manufacturing NFT sales. Planet Co-Owners will also receive a percentage income from ALL NEW in-game NFT sales from the Homeworld and Marketplace revenue.
            </h6>
            <h6 className="p-1 text-center">
            <a href="https://medium.com/cosmic-force/planet-co-ownership-cded71e9bad5" target="_blank">PLANET CO-OWNERSHIP article</a>
            </h6>
            </Row>
            <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/co-owner-infographic.jpg' className='img-fluid' alt='...' />
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            <h5 className="p-4 text-center">
              BONUS you will also get a COSMIC LITE NODE NFT
            </h5>
          </Row>
            <Row className="g-8">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '450px' }}>
            <img  src='./images/COSMIC_LITE_NODE_RELEASE.gif' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
            <h6 className="p-1 text-center">
            <a href="https://medium.com/cosmic-force/cosmic-blockchain-validator-nodes-176746a17516" target="_blank">Cosmic Blockchain VALIDATOR NODE article</a>
             </h6>
          </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/UNP6gKel7ow?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/1XuLv5zSudk?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
